import { Stack, Typography } from '@mui/material';
import { variants } from '../../../variants/variants';
import UserAvatar from '../../../common/UserAvatar';
import { Box } from '@mui/material';

const CustomRow = ({ user }) => {
  return (
    <Stack
      sx={{
        borderColor: 'divider',
        width: 1,
      }}
    >
      <Stack direction={'row'} alignItems={'center'} sx={{ border: 0 }}>
        <UserAvatar src={user[5]} />
        <Box sx={{ ml: 1 }}>
          <Typography sx={{ fontSize: variants.BODY, fontWeight: 600 }}>{user[1]}</Typography>
          {/* <Typography sx={{ fontSize: variants.BODY, }}>{user[2]}</Typography> */}
          <Typography sx={{ fontSize: variants.TINY, color: variants.typography.inactive.hover }}>{user[3]}</Typography>
        </Box>

        <Stack alignItems='flex-end' sx={{ ml: 'auto' }}>
          <Typography
            sx={{
              fontSize: variants.TINY,
              fontWeight: user?.read ? 400 : 600,
            }}
          >
            {user[6].split(' - ')[0]}
          </Typography>
          <Typography sx={{ fontSize: variants.BODY }}>{user[7]}</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
export default CustomRow;
